/**
 * URL builders for production-file generation.
 *
 * The logo auto-trace endpoint lives on the CUSTOMER api root
 * (`{root}/download/vectorized-logo`), while the admin app's axios base is
 * `{root}/admin` — so the `/admin` suffix is stripped to reach it.
 */
export function productionStorageUrl(): string {
  return `${(import.meta as any).env?.VITE_APP_FILE_URL ?? ''}/`;
}

export function customerApiRoot(baseUrl?: string): string {
  const base = baseUrl ?? String((import.meta as any).env?.VITE_APP_BASE_URL ?? '');
  return base.replace(/\/+$/, '').replace(/\/admin$/i, '');
}

export function buildVectorizeLogoUrl(s3Key: string, baseUrl?: string): string {
  return `${customerApiRoot(baseUrl)}/download/vectorized-logo?path=${encodeURIComponent(
    s3Key
  )}&format=svg&generate=1`;
}
